import { useUnread } from '../hooks'

/**
 * Badge z liczbą nieprzeczytanych dyskusji dla danej encji, do wpięcia
 * w pasek zakładek (np. ContractDetailPage). Łączny licznik z
 * `/api/collab/me/unread` - per-wątek read-state nie jest jeszcze
 * dostępny z API. Nic nie renderuje gdy 0.
 */
export function DiscussionsTabBadge({ entityRef }: { entityRef: string }) {
  const { data } = useUnread(entityRef)
  const count = data?.count ?? 0
  if (count <= 0) return null
  return (
    <span className="ml-1.5 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-[11px] font-semibold rounded-full bg-rose-100 text-rose-700">
      {count > 99 ? '99+' : count}
    </span>
  )
}
